import { type DeliveryNoteListItem } from '~/data/deliveryNote/types';

export const getSellerOrderReferences = (
  assetMain: Partial<DeliveryNoteListItem> = {},
) => {
  const sellerOrderReferences = [];

  if (assetMain?.assetState?.body?.transaction?.logisticsPackage)
    for (const logisticsPackage of assetMain?.assetState?.body?.transaction
      ?.logisticsPackage) {
      if (logisticsPackage?.lineItem)
        for (const lineItem of logisticsPackage?.lineItem) {
          if (
            lineItem?.agreement?.sellerOrder &&
            !sellerOrderReferences.includes(lineItem.agreement?.sellerOrder)
          ) {
            sellerOrderReferences.push(lineItem.agreement.sellerOrder);
          }
        }
    }

  return sellerOrderReferences.join(', ');
};
